export enum Commands {
    GO_TO_PAGE,
    CHANGE_IMAGE_PRINT_MODE,
    AUTO_DETECT_FRAME,
    CHANGE_FRAME,
    DETECT_PALETTE,
    CLONE_TILE,
    DELETE_TILE,
    DELETE_ALL_IMAGES,
    CHANGE_SIZE,
    CHANGE_OPTION,
    OPEN_UPLOAD_WINDOW,
    PROPERTY_CHANGED,
    MAKE_ORDER,
    IMAGES_CHANGED
}
